/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Affiliate_TitleInputs */

const en_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate Hub`)
};

const es_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de afiliados`)
};

const fr_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub d'affiliation`)
};

const de_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate-Hub`)
};

const ja_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アフィリエイトハブ`)
};

const zh_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推广中心`)
};

const ar_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مركز التسويق بالعمولة`)
};

const id_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Afiliasi`)
};

const it_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub Affiliati`)
};

const ru_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Партнерский центр`)
};

const pt_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub de Afiliados`)
};

const ko_affiliate_title = /** @type {(inputs: Affiliate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어필리에이트 허브`)
};

/**
* | output |
* | --- |
* | "Affiliate Hub" |
*
* @param {Affiliate_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const affiliate_title = /** @type {((inputs?: Affiliate_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Affiliate_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_affiliate_title(inputs)
	if (locale === "es") return es_affiliate_title(inputs)
	if (locale === "fr") return fr_affiliate_title(inputs)
	if (locale === "de") return de_affiliate_title(inputs)
	if (locale === "ja") return ja_affiliate_title(inputs)
	if (locale === "zh") return zh_affiliate_title(inputs)
	if (locale === "ar") return ar_affiliate_title(inputs)
	if (locale === "id") return id_affiliate_title(inputs)
	if (locale === "it") return it_affiliate_title(inputs)
	if (locale === "ru") return ru_affiliate_title(inputs)
	if (locale === "pt") return pt_affiliate_title(inputs)
	return ko_affiliate_title(inputs)
});